import axios from '../axios';

export default {
  loadAllBarriers (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/barrier?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getSipStatus: (id) => axios.put(`/barrier/${id}/sip-status`),
  updateSnapshot (id) {
    return new Promise((resolve, reject) => {
      axios.put(`/barrier/${id}/snapshot`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getSipHistory: (id) => axios.get(`/barrier/${id}/sip-status-logs`),
  exportSipHistoryCsvBarrier (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/sip-status-logs/export-csv`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  newBarrier (params) {
    return new Promise((resolve, reject) => {
      axios.post('/barrier', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getBarrier (id, includes = []) {
    const includeList = Array.isArray(includes) ? includes.filter(Boolean) : [];
    const query = includeList.length ? `?include=${encodeURIComponent(includeList.join(','))}` : '';
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}${query}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getBarrierInfoEdit (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/edit`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateBarrier (id, params) {
    return new Promise((resolve, reject) => {
      axios.put(`/barrier/${id}`, params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeBarrier (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/barrier/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  addBarrierDoorphone (barrier, doorphones) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${barrier}/doorphone`, doorphones)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeBarrierDoorphone (barrier, doorphone) {
    return new Promise((resolve, reject) => {
      axios.delete(`/barrier/${barrier}/doorphone/${doorphone}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  openBarrier (id, doornum) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${id}/open?relay_index=${doornum}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getCheckCamerasBarrier (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/camera`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getStatusCondition (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/status-condition`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  blockBarrier (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${id}/block`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  unlockBarrier (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${id}/unlock`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getJournalGrzOpen (id, startDate, endDate, sort, carNumbers) {
    const params = new URLSearchParams();
    if (Array.isArray(carNumbers) && carNumbers.length > 0) {
      carNumbers.forEach(carNumber => {
        params.append('car_number[]', carNumber);
      });
    }
    params.append('start_date', startDate);
    params.append('end_date', endDate);
    // params.append('sort', sort);

    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/journal-grz-open?${params.toString()}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getImageJournalGrz (id, dateTime) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/image-journal-grz?date_time=${dateTime}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateCarNumber (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${id}/car-number`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  makeCall (phone) {
    return new Promise((resolve, reject) => {
      axios.post('/barrier/make-call', { phone: phone })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  importCarNumbersByCsv (id, formData, actionShould) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${id}/car-number`, formData, {
        params: { action_should: actionShould },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateCoordsBarrier (id, barrier) {
    return new Promise((resolve, reject) => {
      axios.put(`/barrier/${id}/update-coords`, barrier)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  downloadListCarsNumbers (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${id}/car-number-report`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          resolve(blob);
        })
        .catch(error => reject(error));
    });
  },
  addAdditionalAddress (id, address) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${id}/add-additional-address`, {
        address: address,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeAdditionalAddress (idBarrier, idAddress) {
    return new Promise((resolve, reject) => {
      axios.delete(`/barrier/${idBarrier}/remove-additional-address/${idAddress}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportCsv () {
    return new Promise((resolve, reject) => {
      axios.get('/barrier/export-csv', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getWhitePhoneNumbers (barrierId) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${barrierId}/white-phone-numbers`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  createWhitePhoneNumber (barrierId, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${barrierId}/white-phone-numbers`, params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateWhitePhoneNumber (barrierId, whitePhoneNumberId, params) {
    return new Promise((resolve, reject) => {
      axios.put(`/barrier/${barrierId}/white-phone-numbers/${whitePhoneNumberId}`, params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteWhitePhoneNumber (barrierId, whitePhoneNumberId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/barrier/${barrierId}/white-phone-numbers/${whitePhoneNumberId}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  importWhitePhoneNumbers (barrierId, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/barrier/${barrierId}/white-phone-numbers/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportWhitePhoneNumbers (barrierId) {
    return new Promise((resolve, reject) => {
      axios.get(`/barrier/${barrierId}/white-phone-numbers/export`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};
